import { Deserializable } from '../deserializable';
import { UserBasicDetails } from './user-basic-details';
import { UserFiaPins } from './user-fia-pins';
import { Reason } from 'src/app/shared/models/users/reason';
import { Tag } from 'src/app/shared/models/general/tag';

export class UserTradingSearchResponse implements Deserializable {
  public selected: boolean = false;
  public userId: number;
  public userDetails: UserBasicDetails;
  public spouse: UserBasicDetails;
  public spouseAccountBalance: number;
  public accountBalance: number;
  public accountBalanceDate: Date;
  public arbFacilitatorId: number;
  public brokerId: number;
  public arbRate: number;
  public sdaAvailable: number;
  public fiaAvailable: number;
  public userFiaPinsAvailableAmount: number;
  public userFiaPins: UserFiaPins[] = [];
  public hasPinInReview: boolean;
  public assignedTo: UserBasicDetails;
  public suggestedTradeAmount: number = 0;
  public suggestedTradeType: string;
  public lastTransactionDate: Date;
  public lastTransactionAmount: number;
  public canTrade: boolean;
  public tradeReason: string;
  public tradeReasonDetail: string;
  public plan: string;
  public suggestedTradeFiaPinRatio: string;
  public suggestedTradeSdaFiaRatio: string;
  public preferredMinArbRate: number;
  public maxTradeAmount: number;
  public pips: number;
  public overridePips: boolean = false;
  public warnings: Reason[] = [];
  public tags: Tag[] = [];

  public overrideAccountBalance: boolean = false;
  public overriddenAccountBalance: number;

  // additional fields needed - check if these are ok with mapping if not coming from api service
  public sdaAmount: number = 0;
  public bookAsStandard: boolean = false;
  public billingPlanType: number = 0;

  public profileIsLoading: boolean = false;

  public clientNotes: string = '';
  public spouseFiaAvailable: number;
  public spouseSdaAvailable: number;
  public spousePinsAvailableAmount: number;
  public spousePinCount: number;
  public displaySpouseFigures: boolean = false;

  deserialize(input: any): this {
    Object.assign(this, input);
    return this;
  }

  public ShouldBookAsStandard() {
    return this.plan == 'Standard';
  }
}
